import type {
  ReservationPartyLookupDto,
  ReservationPartyLookupRequest,
} from '../../Reservation/Types/reservationTypes';

export type InvoiceReservationPartyLookupRequest = ReservationPartyLookupRequest;

export interface InvoiceReservationPartyLookup {
  id: number;
  partyType: 'individual' | 'organization';
  displayName: string;
  email?: string;
  phone?: string;
  taxId?: string;
  addressSummary?: string;
}

const toOptionalString = (value: string | null | undefined): string | undefined => {
  if (typeof value !== 'string') {
    return undefined;
  }

  const trimmed = value.trim();
  return trimmed === '' ? undefined : trimmed;
};

export const mapReservationPartyLookupToInvoiceLookup = (
  source: ReservationPartyLookupDto | undefined | null
): InvoiceReservationPartyLookup | undefined => {
  if (!source) {
    return undefined;
  }

  return {
    id: source.id,
    partyType: source.partyType,
    displayName: source.displayName,
    email: toOptionalString(source.email),
    phone: toOptionalString(source.phone),
    taxId: toOptionalString(source.taxId),
    addressSummary: toOptionalString(source.addressSummary),
  };
};